import React from "react";
import { Box, Paper, Stack, Skeleton } from "@mui/material";

const AssessmentSkeleton = () => {
  return (
    <Box sx={{ width: "100%" }}>
      {[1, 2, 3].map((item) => (
        <Paper key={item} elevation={0} sx={{ mb: 2, p: 2.5, borderRadius: 2, border: "1px solid #e2e8f0" }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.5 }}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="text" width={200} height={30} />
          </Stack>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
          </Box>
        </Paper>
      ))}
    </Box>
  );
};

export default AssessmentSkeleton;